import PropTypes from "prop-types";

export const AssetPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  asset_url: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
});

export const WebAssetPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  asset_url: PropTypes.string.isRequired,
  url: PropTypes.string,
  content: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
});

export const NotificationPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  topic: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  posted_on: PropTypes.string.isRequired,
  is_read: PropTypes.bool.isRequired,
});

export const CampaignPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  assets: PropTypes.array.isRequired,
});



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/constants/propTypes.js